import { render, staticRenderFns } from "./NewSetting.vue?vue&type=template&id=1c137efc&"
import script from "./NewSetting.vue?vue&type=script&lang=js&"
export * from "./NewSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports